import React from "react";
import * as Icon from "react-feather";
import { inject, observer } from "mobx-react";
import { entries } from "mobx";
import LoaderSpinner from "./loader-spinner";

import * as M from "@material-ui/core";

const Alert = ({ store }) =>
  store.$alert.list.size > 0 && (
    <div
      className="fixed flex flex-col bottom-0 right-0 z-50 mr-4 mb-4 min-h-0"
      style={{ minHeight: 0 }}
    >
      {entries(store.$alert.list).map(a => (
        <div
          className="bg-primary text-white uppercase mt-2 flex content-between items-center rounded-sm"
          key={a[0]}
        >
          {(!a[1].label || a[1].loader === "circle") && (
            <LoaderSpinner type={a[1].loader || "circle"} />
          )}
          {a[1].label && <span className="label pl-4 pr-2">{a[1].label}</span>}
          {a[1].label && (
            <M.IconButton className="ml-2 bg-transparent" onClick={e => store.$alert.delete(a[0])}>
              <Icon.X />
            </M.IconButton>
          )}
        </div>
      ))}
    </div>
  );

export default inject("store")(observer(Alert));
